import React, { useState } from "react";
import {
  Card,
  ScheduleBody,
  LeftInfo,
  LeftInfoDate,
  LeftInfoTime,
  PatientInfoBody,
  PatientTitle,
  PatientValue,
  ConfirmButton,
  CancelButton,
  ButtonBody,
  ChangeDateButton,
  ShowMoreBox,
  ImageShowMore,
  ShowMore,
  MobileTextBox,
  ShowMoreDivision,
} from "./styles";

export const ScheduleCard = ({
  telemedicina,
  date,
  time,
  name,
  consulta,
  especialidade,
  profissional,
  onStart,
  onCancel,
  onChangeDate,
  enableReschedule,
  enableStart,
}) => {
  const [showMore, setShowMore] = useState(false);
  const _showMore = () => {
    setShowMore(!showMore);
  };

  return (
    <Card>
      <ScheduleBody showMore={showMore}>
        <LeftInfo showMore={showMore} telemedicina={telemedicina}>
          <LeftInfoDate>{date}</LeftInfoDate>
          <LeftInfoTime>{time}</LeftInfoTime>
        </LeftInfo>
        <PatientInfoBody showMore={showMore}>
          <PatientTitle>Paciente</PatientTitle>
          <PatientValue>{name}</PatientValue>
        </PatientInfoBody>
        <PatientInfoBody hideMobile={true}>
          <PatientTitle>Consulta</PatientTitle>
          <PatientValue>{consulta}</PatientValue>
        </PatientInfoBody>
        <PatientInfoBody hideMobile={true}>
          <PatientTitle>
            {telemedicina ? "Especialidade" : "Programa"}
          </PatientTitle>
          <PatientValue>{especialidade}</PatientValue>
        </PatientInfoBody>
        <PatientInfoBody hideMobile={true}>
          <PatientTitle>Profissional</PatientTitle>
          <PatientValue>{profissional}</PatientValue>
        </PatientInfoBody>
        <ButtonBody>
          {enableStart && (
            <ConfirmButton onClick={() => onStart()}>Ingressar</ConfirmButton>
          )}
          <CancelButton onClick={() => onCancel()}>Cancelar</CancelButton>
          {!telemedicina && enableReschedule && (
            <ChangeDateButton onClick={() => onChangeDate()}>
              Reagendar
            </ChangeDateButton>
          )}
        </ButtonBody>
        <ShowMoreBox showMore={showMore} onClick={() => _showMore()}>
          {showMore ? (
            <ImageShowMore src="/img/show-less.png" />
          ) : (
            <ImageShowMore src="/img/show-more.png" />
          )}
        </ShowMoreBox>
      </ScheduleBody>
      {showMore && (
        <ShowMore>
          <MobileTextBox>
            <PatientTitle>Consulta:&nbsp;</PatientTitle>
            <PatientValue>{consulta}</PatientValue>
          </MobileTextBox>
          <MobileTextBox>
            <PatientTitle>
              {telemedicina ? "Especialidade:" : "Programa:"}
            </PatientTitle>
            <PatientValue>&nbsp;{especialidade}</PatientValue>
          </MobileTextBox>
          <MobileTextBox>
            <PatientTitle>Profissional:&nbsp;</PatientTitle>
            <PatientValue>{profissional}</PatientValue>
          </MobileTextBox>
          <ShowMoreDivision />
          {enableStart && (
            <ConfirmButton onClick={() => onStart()}>Ingressar</ConfirmButton>
          )}
          {telemedicina && (
            <CancelButton onClick={() => onCancel()}>Cancelar</CancelButton>
          )}
          {!telemedicina && enableReschedule && (
            <ChangeDateButton onClick={() => onChangeDate()}>
              Reagendar
            </ChangeDateButton>
          )}
        </ShowMore>
      )}
    </Card>
  );
};
